<template>
  <div class="basket-total">
    <div v-if="price.printPriceOld" class="basket-total__row">
      <div>{{ messages.totalPrice }}</div>
      <div>{{ price.printPriceOld }}</div>
    </div>
    <div v-if="price.printDiscount" class="basket-total__row">
      <div>{{ messages.discountPrice }}</div>
      <DefSale>{{ price.printDiscount }}</DefSale>
    </div>
    <div v-if="delivery.printPrice" class="basket-total__row">
      <div>{{ messages.deliveryTitle }}</div>
      <div :class="{ 'basket-total__free': delivery.price === 0 }">{{ delivery.printPrice }}</div>
    </div>

    <div v-if="getTaxPrice?.isShowTax" class="basket-total__row">
      <div>{{ resultMessages?.tax }} ({{ getTaxPrice?.printTaxPercent }})</div>
      <div>{{ getTaxPrice?.printTax }}</div>
    </div>

    <div v-if="price.printPrice" class="basket-total__row">
      <div>{{ messages.total_amount }}</div>
      <div class="basket-total__total">{{ price.printPrice }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import DefSale from '@components/Def/DefSale/DefSale.vue';
import { useStore } from '@/store';
import { computed } from 'vue';

const { state } = useStore();

const price = computed(() => state.basket.data.price);
const delivery = computed(() => state.basket.data.delivery);
const messages = computed(() => state.basket.data.messages);
const resultMessages = computed(() => state.results.messages);
const checkoutBasketPrice = computed(() => state.checkout.data?.vue?.basketPrice);

const getTaxPrice = computed(() => {
  // is page checkout? get data from checkout store
  if (checkoutBasketPrice.value) {
    return checkoutBasketPrice.value;
  }
  return price.value;
});
</script>

<style lang="scss" scoped>
.basket-total {
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 12px;
  font-size: 16px;
  font-weight: 500;
  line-height: 125%;
  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  &__total {
    font-size: 20px;
    font-weight: 600;
    line-height: 125%;
    @include point-lg {
      font-size: 24px;
    }
  }
  &__free {
    color: var(--color-green);
  }
  :deep(.def-sale) {
    font-size: rem(14);
  }
}
</style>
